import React from 'react'
import { InputGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import { TextInput } from '@ztechapps/webui.input'

import isEmpty from 'lodash/isEmpty'

export type TaskInputProps = {
  value?: string
  onAdd: (taskName: string) => Promise<void>
  placeholder?: string
  disabled?: boolean
}
export const TaskInput = ({ value, onAdd, placeholder = 'Enter a task name.', disabled }: TaskInputProps) => {
  const [internalValue, setInternalValue] = React.useState(value)

  const inputRef = React.useRef(null)
  const canAdd = !disabled && !isEmpty(internalValue)

  const internalAdd = async (taskName: string) => {
    //if disabled do not allow adding
    if (!canAdd) return

    await onAdd(taskName)
    setInternalValue('')
    inputRef?.current?.focus?.()
  }
  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      return internalAdd(internalValue)
    }
  }

  return (
    <InputGroup>
      <TextInput
        inputRef={inputRef}
        value={internalValue}
        onChange={(e) => {
          setInternalValue(e?.target?.value)
        }}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
      />
      <BusyButton
        icon="plus"
        text="Add"
        bsStyle="primary"
        onClick={() => internalAdd(internalValue)}
        disabled={!canAdd}
      />
    </InputGroup>
  )
}
